import Vue from 'vue'
import Vuex from 'vuex'
import personas from './modules/personas.module'
//import idiomas from './modules/idiomas.module'
import prematricula from './modules/prematricula.module'
import localizaciones from './modules/localizaciones.module'
import errors from './modules/errors.module'

Vue.use(Vuex)

/**
 * Set the store modules
 * 
 */

const store =  new Vuex.Store({

    modules: {

        Personas: personas,
        //Idiomas: idiomas,
        Prematricula: prematricula,
        Localizaciones: localizaciones,
        Errors: errors

    }

})

export default store